;(function ($, undefined) {
    $.fn.ForceStringOnly = function () {
        return this.each(function () {
            $(this).bind('keypress', function(e) {
                return e.keyCode != 13;
            });
        });
    };

    $.fn.ForceNumericOnly = function () {
        return this.each(function () {
            $(this).keydown(function (e) {

                var key = e.charCode || e.keyCode || 0;
                // '.'          190
                // Numpad '.'   110
                // ','          188
                // allow backspace(8), tab(9), delete(46), ctrl(17), arrows(37-40), numbers(48-57) and keypad numbers(96-105) ONLY
                return e.ctrlKey ||
                    key === 8 ||
                    key === 9 ||
                    key === 46 ||
                    key === 17 ||
                    (key >= 37 && key <= 40) ||
                    (key >= 48 && key <= 57) ||
                    (key >= 96 && key <= 105) ||
                    key === 190 ||
                    key === 188 ||
                    key === 110;
            });
        });
    };

    $.fn.ForceDateOnly  = function () {
        return this.each(function () {
            $(this).keydown(function (e) {

                var key = e.charCode || e.keyCode || 0;
                // '/'          191
                // '.'          190
                // Numpad '.'   110
                // '-'          189
                // Numpad '-'   109
                // allow backspace(8), tab(9), delete(46), ctrl(17), arrows(37-40), numbers(48-57) and keypad numbers(96-105) ONLY
                return e.ctrlKey ||
                    key === 8 || 
                    key === 9 || 
                    key === 46 || 
                    key === 17 ||
                    (key >= 37 && key <= 40) ||
                    (key >= 48 && key <= 57) ||
                    (key >= 96 && key <= 105) ||
                    key === 191 || 
                    key === 190 || 
                    key === 110 || 
                    key === 189 || 
                    key === 109;
            });
        });
    };
})(jQuery);
